<template>
    <div class="rent-out">
        <RentOutHero />
        <MainUsps for="owners" />
        <Press />
        <RentalOutProcess />
        <PriceCalculator id="price-calculator" />
        <InterviewBlurb v-if="$te('magazine.article_slugs.owner_interview')" type="owner" />
        <EBook />
        <OwnerUsps />
        <Contact />
    </div>
</template>

<router>
{
    meta: {
        hideGettingStartedProgressBar: true
    }
}
</router>

<script>
import RentOutHero from '~/components/sections/RentOutHero.vue';
import RentalOutProcess from '~/components/sections/RentalOutProcess.vue';
import InterviewBlurb from '~/components/sections/InterviewBlurb.vue';
import Contact from '~/components/sections/Contact.vue';
import Press from '~/components/sections/Press.vue';
import MainUsps from '~/components/sections/MainUsps.vue';
import OwnerUsps from '~/components/sections/OwnerUsps.vue';
import PriceCalculator from '~/components/sections/PriceCalculator.vue';
import EBook from '~/components/sections/EBook.vue';

export default {
    components: {
        RentOutHero,
        InterviewBlurb,
        RentalOutProcess,
        Contact,
        Press,
        MainUsps,
        OwnerUsps,
        PriceCalculator,
        EBook,
    },
    head() {
        const title = this.$t('pages.rent_out.seo_page_title');
        const description = this.$t('pages.rent_out.seo_page_description');

        return {
            title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: description,
                },
                { hid: 'og-title', property: 'og:title', content: title },
                { hid: 'og-description', property: 'og:description', content: description },
            ],
        };
    },
    nuxtI18n: {
        paths: {
            se: '/hyra-ut-husbil-husvagn',
            'fi-sv': '/hyra-ut-husbil-husvagn',
            en: '/rent-out-motorhome-caravan',
            de: '/wohnmobil-wohnwagen-vermieten',
            at: '/wohnmobil-wohnwagen-vermieten',
            fi: '/anna-vuokralle-matkailuauto-matkailuvaunu',
            no: '/lei-ut-bobil-campingvogn',
            dk: '/udlej-autocamper-campingvogn',
            ch: '/wohnmobil-wohnwagen-vermieten',
            fr: '/mettre-en-location',
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.rent-out {
    background: $white;

    @include md {
        padding-top: 40px;
    }
}
</style>
